<mat-toolbar class="footer__toolbar">
  <div class="wrapper">
    <div class="wrapper__content" fxLayout="column">
      <div fxFlex fxLayout="column" fxLayout.gt-sm="row" fxLayoutAlign="start start" fxLayoutAlign.gt-sm="start center">
        <div class="footer__logo">
          <img src="assets/img/img_scf_logo_txt_black.svg" alt="Logo SABADELL" />
        </div>
        <ul
          fxFlex
          fxFlex.gt-sm="1 1 auto"
          fxLayout="column"
          fxLayout.gt-xs="row wrap"
          fxLayout.gt-sm="row nowrap"
          fxLayoutAlign="stretch start"
          fxLayoutAlign.gt-sm="space-between center"
          class="footer__nav d-print-none"
        >
          <li fxFlex fxFlex.gt-xs="0 1 calc(50% - 16px)" fxFlex.gt-sm="0 0 auto" fxLayout="row">
            <a
              *ngIf="langActive === 'es-ES'"
              id="servicioLinkFooterEs"
              mat-button
              mat-button-link
              fxFlex="1 0 auto"
              fxLayout="row wrap"
              fxLayoutAlign="start center"
              fxLayoutAlign.gt-md="center center"
              (click)="
                openPage(
                  'https://www.bancsabadell.com/cs/Satellite/SabAtl/Reclamaciones/GBS_Generico_FA/2000031330915/1191332198208/es/'
                )
              "
            >
              {{ 'footer.toolbar.servicio' | translate }}
            </a>
            <a
              *ngIf="langActive === 'es-CAT'"
              id="servicioLinkFooterCa"
              mat-button
              mat-button-link
              fxFlex="1 0 auto"
              fxLayout="row wrap"
              fxLayoutAlign="start center"
              fxLayoutAlign.gt-md="center center"
              (click)="
                openPage(
                  'https://www.bancsabadell.com/cs/Satellite/SabAtl/Reclamaciones/GBS_Generico_FA/2000031330915/1191332198208/ca/'
                )
              "
            >
              {{ 'footer.toolbar.servicio' | translate }}
            </a>
          </li>
          <li
            *ngFor="let option of footerLinks"
            fxFlex
            fxFlex.gt-xs="0 1 calc(50% - 16px)"
            fxFlex.gt-sm="0 0 auto"
            fxLayout="row"
          >
            <a
              *ngIf="option.text != 'footer.cookiesSettings'"
              id="option.id"
              mat-button
              mat-button-link
              fxFlex="1 0 auto"
              fxLayout="row wrap"
              fxLayoutAlign="start center"
              fxLayoutAlign.gt-md="center center"
              (click)="openPage(option.url)"
              >{{ option.text | translate }}</a
            >
            <a
              *ngIf="option.text === 'footer.cookiesSettings'"
              id="option.id"
              mat-button
              mat-button-link
              fxFlex="1 0 auto"
              fxLayout="row wrap"
              fxLayoutAlign="start center"
              fxLayoutAlign.gt-md="center center"
              onclick="OneTrust.ToggleInfoDisplay()"
              >{{ option.text | translate }}</a
            >
          </li>
        </ul>
      </div>
      <div *ngIf="!isThirdparty" class="registro-mercantil">
        <p [innerHtml]="'footer.registroMercantil' | translate"></p>
      </div>
    </div>
  </div>
</mat-toolbar>
